module.exports = {
  friends: {
    oneActorHasMultipleNewFriends: '%(username1)s a %(nbOfFriends)d nouveaux amis',
    twoSingles: '%(username1)s et %(username2)s sont maintenant amis',
  },
  loadMore: 'Charger les prises suivantes',
  endOfFeed: 'Toutes les prises de ce concours sont affichées !',
  joinTeam: {
    joinButton: 'Rejoindre votre équipe',
    teamNotFound:
      "Aucune équipe n'a pu être trouvée avec ce code. Merci de vérifier le code, et de nous contacter si vous avez besoin d'aide.",
    getTeamError:
      'Une erreur est survenue, merci de réessayer ultérieurement ou de nous contacter si le problème persiste.',
    alreadyJoined: 'Vous êtes déjà inscrit !',
    pleaseLogin: 'Merci de vous connecter à votre compte Fishfriender pour rejoindre une équipe.',
    joinedAlert: 'Équipe rejointe, bienvenue !',
    team: {
      teamName: 'Équipe : ',
      joinCode: 'Code à transmettre à vos co-équipiers : ',
    },
    teamFullAlert: "L'équipe que vous souhaitez rejoindre est déjà complète. Désolé !",
  },
  joinWithPassword: {
    joinButton: "Rejoindre l'évenement",
    joinText: "Merci de renseigner le mot de passe fourni par l'organisateur lors de votre inscription.",
    wrongPassword:
      "Désolé, le mot de passe ne correspond pas. Merci de vérifier auprès de l'organisateur que vous avez bien le bon !",
    unknownError:
      'Une erreur est survenue, merci de réessayer ultérieurement ou de nous contacter si le problème persiste.',
    alreadyJoined: 'Vous êtes inscrit !',
    pleaseLogin: 'Merci de vous connecter à votre compte Fishfriender pour rejoindre cet évènement.',
    joinedAlert: 'Évènement rejoint, bienvenue !',
  },
  ranking: {
    angler: 'Pêcheur',
    catchNotFound: "Cette prise n'est plus visible",
    individualNoRound: {
      noCatches: 'Aucune prise enregistrée pendant cet événement',
    },
  },
}
